/**
 * internal dependencies
 */
import { awsApiInstance } from '../api/aws-api';
import { getCognitoStore } from '../auth/cognito-store';

const CognitoLogoutUser = async () => {
  const { AccessToken, RefreshToken } = getCognitoStore();

  const modalData = {
    access: AccessToken,
    refresh: RefreshToken
  };

  const { data } = await awsApiInstance.post('/auth/log-out', modalData);
  return data;
};

export default CognitoLogoutUser;